import { Comment } from 'types'

export enum CommentActions {
  SET_COMMENT_PROMPT_TEXT = 'SET_COMMENT_PROMPT_TEXT',
  COMMENTS_SET_ACTIVE = 'COMMENTS_SET_ACTIVE',
  NEW_COMMENT_ACTIVE_SET = 'NEW_COMMENT_ACTIVE_SET',
  COMMENTS_IS_DELETING_OR_RESOLVING_SET = 'COMMENTS_IS_DELETING_OR_RESOLVING_SET',
  COMMENT_SET_HIGHLIGHTED = 'COMMENT_SET_HIGHLIGHTED',

  UPSERT_COMMENT = 'UPSERT_COMMENT',
  UPSERT_COMMENTS = 'UPSERT_COMMENTS',
  MARK_COMMENT_AS_READ = 'MARK_COMMENT_AS_READ',
  PIN_COMMENT = 'PIN_COMMENT',
  UNPIN_COMMENT = 'UNPIN_COMMENT',
  DELETE_COMMENT = 'DELETE_COMMENT',
  RESOLVE_COMMENT = 'RESOLVE_COMMENT',
  UNRESOLVE_COMMENT = 'UNRESOLVE_COMMENT',
  UPSERT_COMMENTS_HIDDEN_LAYERS_IDS = 'UPSERT_COMMENTS_HIDDEN_LAYERS_IDS',
}

export function upsertComment(comment: Comment) {
  return {
    type: CommentActions.UPSERT_COMMENT,
    payload: { comment },
  }
}

export function upsertComments(comments: Comment[]) {
  return {
    type: CommentActions.UPSERT_COMMENTS,
    payload: { comments },
  }
}

export function markCommentAsRead(id: number) {
  return {
    type: CommentActions.MARK_COMMENT_AS_READ,
    payload: { id },
  }
}

export function pinComment(id: number) {
  return {
    type: CommentActions.PIN_COMMENT,
    payload: { id },
  }
}

export function unpinComment(id: number) {
  return {
    type: CommentActions.UNPIN_COMMENT,
    payload: { id },
  }
}

export function deleteComment(id: number) {
  return {
    type: CommentActions.DELETE_COMMENT,
    payload: { id },
  }
}

export function resolveComment(id: number) {
  return {
    type: CommentActions.RESOLVE_COMMENT,
    payload: { id },
  }
}

export function unresolveComment(id: number) {
  return {
    type: CommentActions.UNRESOLVE_COMMENT,
    payload: { id },
  }
}

export function setNewCommentActive(active: boolean) {
  return {
    type: CommentActions.NEW_COMMENT_ACTIVE_SET,
    payload: active,
  }
}

export function upsertCommentsHiddenLayersIds(ids: string[]) {
  return {
    type: CommentActions.UPSERT_COMMENTS_HIDDEN_LAYERS_IDS,
    payload: { ids },
  }
}
